import { ProblemDetail } from '@endion/types';
import { responseAsProblemDetail } from './error-handler';

export default function withSubmitHandler<TFormData>(
  onSubmit: (formData: TFormData) => Promise<void>,
  setError: (errorMessage: string, problemDetail?: ProblemDetail) => void,
) {
  return async (formData: TFormData) => {
    try {
      await onSubmit(formData);
    } catch (e) {
      let errorMessage = 'Ocurrió un error desconocido, reintente o contacte al soporte.';
      if (responseAsProblemDetail(e)) {
        errorMessage = 'Ocurrió un error al enviar el formulario. Por favor, intenta nuevamente.';
        setError(errorMessage, e);
      } else {
        setError(errorMessage);
      }
      // we have to throw the error to keep the form in the error state
      throw new Error(errorMessage);
    }
  };
}
